import { types as t } from 'mst-effect';

import { withRunInAction } from 'utils/withRunInAction';

export interface UserWorker {
  id: string;
  firstName?: string;
  lastName?: string;
  type: 'user';
}

export interface ModelWorker {
  id: string;
  name?: string;
  type: 'model';
}

export interface SelectAllWorker {
  id: string;
  firstName?: string;
  lastName?: string;
  type: 'selectAll';
}
export type WorkerData = UserWorker | ModelWorker | SelectAllWorker;

export const selectAllWorkerItem: SelectAllWorker = {
  id: 'select_all_id',
  firstName: 'All',
  lastName: 'Labelers',
  type: 'selectAll',
};
/**
 * Store that annotation labeler filter value
 */
export const LabelerFilterStore = t
  .compose(
    withRunInAction(),
    t.model('LabelerFilterStore', {
      labelerFilterValue: t.optional(t.frozen(), selectAllWorkerItem),
    }),
  )
  .actions((self) => ({
    setLabelerFilterValue: (op: WorkerData) => {
      self.labelerFilterValue = op;
    },
  }));
